export const isEmpty = (value: any): boolean => {
    return (
        value === null || // check for null
        value === undefined || // check for undefined
        value === '' || // check for empty string
        (Array.isArray(value) && value.length === 0) || // check for empty array
        (typeof value === 'object' && Object.keys(value).length === 0) // check for empty object
    );
};

export const formatBytes = (bytes: number, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const minimizeFileName = (fileName: string, length: number) => {
    const split = fileName.split(/\.(?=[^.]+$)/);
    const newName = split[0];
    const ext = split[1];
    return newName.length > length ? `${newName.substring(0, 10)}...${ext}` : fileName;
};

// SMS Cost Calculator Helper
export const gsm7bitChars =
    '@£$¥èéùìòÇ\\nØø\\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\\"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
export const gsm7bitExChar = '\\^{}\\\\\\[~\\]|€';
export const gsm7bitRegExp = RegExp('^[' + gsm7bitChars + ']*$');
export const gsm7bitExRegExp = RegExp('^[' + gsm7bitChars + gsm7bitExChar + ']*$');
export const gsm7bitExOnlyRegExp = RegExp('^[\\' + gsm7bitExChar + ']*$');
export const GSM_7BIT = 'GSM_7BIT';
export const GSM_7BIT_EX = 'GSM_7BIT_EX';
export const UTF16 = 'UTF16';

export const smsTypeLength = {
    GSM_7BIT: 160,
    GSM_7BIT_EX: 160,
    UTF16: 70,
};

export const multiSMSTypeLength = {
    GSM_7BIT: 153,
    GSM_7BIT_EX: 153,
    UTF16: 67,
};

export const countGSM7bitEx = (text: string) => {
    let char2, chars;

    chars = () => {
        let _i, _len, _results;
        _results = [];
        for (_i = 0, _len = text.length; _i < _len; _i++) {
            char2 = text[_i];

            if (char2.match(gsm7bitExOnlyRegExp) != null) {
                _results.push(char2);
            }
        }
        return _results;
    };

    return chars.length;
};

export const detectTextEncoding = (text: string) => {
    switch (false) {
        case text.match(gsm7bitRegExp) == null:
            return GSM_7BIT;
        case text.match(gsm7bitExRegExp) == null:
            return GSM_7BIT_EX;
        default:
            return UTF16;
    }
};
// End SMS Cost Calculator Helper
